<div class="ui-modal add-person-to-groups-dialog">
  <div class="header flex-row space-between-center">
    <div>{{ 'PERSON_GROUPS.ADD_PERSON_TO_GROUPS_DIALOG.TITLE' | translate }}</div>
    <span class="ui-icon-close c-p" tabindex="0" role="button" (click)="close()" (keydown.enter)="close()"></span>
  </div>

  <div class="body">
    @if (isPersonGroupsLoading()) {
      <ui-preloader [color]="preloaderColor.blue"></ui-preloader>
    } @else {
      <div class="groups-selector">
        <div class="search-wrapper">
          <ui-search
            class="w-100"
            [formControl]="searchControl"
            [placeholder]="'PERSON_GROUPS.ADD_PERSON_TO_GROUPS_DIALOG.SEARCH_PLACEHOLDER' | translate"
          ></ui-search>
        </div>
        <div class="groups-list">
          @for (group of filteredGroups(); track group._id) {
            <div
              class="group-row flex-row start-center gap-8"
              tabindex="0"
              role="button"
              (click)="toggleGroup(group._id)"
              (keydown.enter)="toggleGroup(group._id)"
              (keydown.space)="$event.preventDefault(); toggleGroup(group._id)"
            >
              <mat-checkbox
                [checked]="isGroupSelected(group._id)"
                (click)="$event.stopPropagation()"
                (change)="setGroupSelected(group._id, $event.checked)"
              ></mat-checkbox>
              <span class="group-name">{{ group.name }}</span>
              <span class="group-count">
                {{ 'PERSON_GROUPS.ADD_PERSON_TO_GROUPS_DIALOG.PEOPLE_COUNT' | translate: { count: group.personsCounter } }}
              </span>
            </div>
          }
        </div>
      </div>
      <ui-button
        class="add-group-button"
        type="secondary"
        iconClass="ui-icon-plus"
        [text]="'PERSON_GROUPS.ADD_PERSON_TO_GROUPS_DIALOG.ADD_NEW_GROUP' | translate"
        (clickAction)="openCreateGroupDialog()"
      ></ui-button>
    }

  </div>

  <div class="footer flex-row end-center">
    <ui-button
      type="primary"
      [disabled]="saveDisabled()"
      [loading]="isAddingPersonsToGroups()"
      [text]="'COMMON.SAVE' | translate"
      (clickAction)="save()"
    ></ui-button>
  </div>
</div>
